import React, { useEffect, useState } from "react";
import { applyServiceWorkerUpdate } from "@/lib/registerServiceWorker";
import { WifiOff, RefreshCcw } from "lucide-react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" ? !navigator.onLine : false
  );
  const [updateReg, setUpdateReg] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    const onUpdate = (e) => setUpdateReg(e.detail);

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("bk:sw-updated", onUpdate);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("bk:sw-updated", onUpdate);
    };
  }, []);

  if (offline) {
    return (
      <div
        className="fixed left-4 bottom-4 z-50 flex items-center gap-3 rounded-full bg-[#1c2723] text-[#f5f6f2] px-4 h-11 shadow-lg"
        data-testid="offline-banner"
      >
        <WifiOff size={14} />
        <span className="text-sm">Çevrimdışısın · son içerikler gösteriliyor</span>
      </div>
    );
  }

  if (updateReg && !dismissed) {
    return (
      <div
        className="fixed left-4 bottom-4 z-50 flex items-center gap-3 rounded-full bg-[#2e4733] text-[#f5f6f2] pl-4 pr-2 h-11 shadow-lg"
        data-testid="sw-update-banner"
      >
        <RefreshCcw size={14} />
        <span className="text-sm">Yeni sürüm hazır</span>
        <button
          data-testid="sw-update-apply"
          onClick={() => applyServiceWorkerUpdate(updateReg)}
          className="ml-1 inline-flex items-center h-8 px-3 rounded-full bg-[#f5f6f2] text-[#1c2723] text-sm font-medium hover:bg-white"
        >
          Güncelle
        </button>
        <button
          data-testid="sw-update-dismiss"
          onClick={() => setDismissed(true)}
          className="text-[#a3aba6] hover:text-[#f5f6f2] text-sm px-2"
          aria-label="Kapat"
        >
          ×
        </button>
      </div>
    );
  }

  return null;
}
